import React from 'react';
//
import { Link } from 'react-router-dom';
import Button from 'antd/lib/button';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
// COMPONENTS
import SignatureModal from './SignatureModal';
import ContractComponent from 'components/common/ContractComponent';
import TextContent from './TextContent';

class ContractPDF extends React.PureComponent {
  renderSignatureModal = () => {
    const {
      contract,
      signModalVisible,
      currentUser,
      onCompleteSignature,
      toggleSignatureModal,
      signatureType,
    } = this.props;

    const userExists = currentUser && currentUser._id;
    let userFullName;
    let signatureText;

    if (userExists) {
      signatureText = contract.contractorSignature;
      userFullName = `${currentUser.profile.firstName} ${currentUser.profile.lastName}`;
    } else {
      userFullName = '';
      signatureText = contract.clientSignature;
    }

    return (
      <SignatureModal
        signModalVisible={signModalVisible}
        toggleSignatureModal={toggleSignatureModal}
        onCompleteSignature={onCompleteSignature}
        onChange={this.props.onChange}
        signatureText={signatureText}
        signatureType={signatureType}
        userFullName={userFullName}
      />
    );
  };

  render() {
    const {
      contract, toggleSignatureModal, signatureType, currentUser,
    } = this.props;

    return (
      <div style={s.container}>
        {this.renderSignatureModal()}
        <Row gutter={40} type="flex" align="middle" justify="center" style={{ minHeight: 100 }}>
          <Col xs={24} sm={15}>
            <TextContent type={signatureType} />
            {contract.status === 'DRAFT' && currentUser && currentUser._id ? (
              <div style={{ marginTop: 10 }}>
                <Link to={`/app/contract/draft/${contract._id}`}>OR, GO BACK AND EDIT </Link>
              </div>
            ) : null}
          </Col>
          <Col xs={24} sm={9} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" size="large" style={s.button} onClick={toggleSignatureModal}>
              SIGN CONTRACT
            </Button>
          </Col>
        </Row>
        <div>
          <ContractComponent contract={contract} />
        </div>
      </div>
    );
  }
}

const s = {
  button: {
    alignSelf: 'center',
    display: 'block',
    minWidth: 225,
    minHeight: 45,
    fontSize: 18,
    maxWidth: '100%',
  },
  container: {
    maxWidth: '97%',
    width: 1100,
    margin: 'auto',
  },
};

export default ContractPDF;



// WEBPACK FOOTER //
// ./src/routes/contract-sign/ContractPDF/index.js